export default __webpack_public_path__ + "img/3befc898841e3e20ead857d8915dc0f8.svg";